var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-button',{staticClass:"mt-2",attrs:{"href":'https://frontend.deliverect.com/orders/' + _vm.deliverectId,"button-text":"View in Deliverect","size":"sm"},scopedSlots:_vm._u([{key:"left-icon",fn:function(){return [_c('base-deliverect-icon',{staticClass:"mr-1 h-5 w-5"})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }